import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import i18n from '@/locales/i18n'
import { Locale, Mode } from '@/types'

type AppInitialStateType = {
  locale: Locale
  mode: Mode
}

const initialState: AppInitialStateType = {
  locale: 'tr',
  mode: 'light',
}

const AppSlice = createSlice({
  name: 'appSlice',
  initialState,
  reducers: {
    commitLocale: (state, action: PayloadAction<Locale>) => {
      state.locale = action.payload
      i18n.changeLanguage(action.payload)
    },
    commitMode: (state, action: PayloadAction<Mode>) => {
      state.mode = action.payload
    },
  },
})

export const { commitLocale, commitMode } = AppSlice.actions

export default AppSlice.reducer
